//@flow

import * as React from "react"
import { TweenMax, Cubic, Back } from "gsap"
import styled from "styled-components"

const DarkPath = styled.path`fill: #0f2d49;`

const LightPath = styled.path`fill: #00b1ec;`

const Container = styled.svg`
  height: ${props => props.height};
  width: ${props => props.width};
`
type Props = { height: string, width: string }

class CammTitle extends React.Component<Props> {
  letters: HTMLElement[]

  constructor(props: Props) {
    super(props)
    this.letters = []
  }

  componentDidMount() {
    TweenMax.set(this.letters, { opacity: 0, y: -40 })
    TweenMax.staggerTo(
      this.letters,
      0.15,
      { opacity: 1, ease: Cubic.easeOut },
      0.05
    )
    TweenMax.staggerTo(this.letters, 0.5, { y: 0, ease: Back.easeOut }, 0.05)
  }

  render() {
    const { height, width } = this.props
    return (
      <Container
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 664 445.1"
        xmlSpace="preserve"
        height={height}
        width={width}
      >
        <g>
          <g>
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M83.3,53.4c-1.5,22-16.1,34.8-40.1,34.8C16.3,88.2,0,71.3,0,44.1C0,16.8,16.4,0,42.6,0
			c24.3,0,38.6,12.2,40.3,33.9H57.1c-0.8-8.5-5.6-12.9-14.2-12.9c-10.6,0-15.8,7.7-15.8,23.2c0,15.2,5.7,23.2,16.5,23.2
			c8.3,0,13.4-4.9,14.2-13.8H83.3z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M94.6,2.2h26.9v61.4H158v22.2H94.6V2.2z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M169,2.2h66.9v20h-40v11.2h33.9v19.2h-33.9v12.9h41.7v20.4H169V2.2z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M271.3,2.2h27.2l29.4,83.7h-26.6l-3.1-11.1h-26.6l-3.3,11.1h-26.4L271.3,2.2z M293.3,57.3l-8.4-29l-8.5,29
			H293.3z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M335.6,2.2h25.5l23.5,38.9c1.4,2.2,3,6.2,4.9,12c-0.6-3.6-0.7-7.4-0.7-11.4V2.2h25.6v83.7h-25.6l-23.5-38.6
			c-1.3-2.1-3-6.2-4.9-12c0.7,4.2,0.7,8,0.7,11.4v39.2h-25.5V2.2z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M473.5,2.2h27.2l29.4,83.7h-26.6l-3.1-11.1h-26.6l-3.3,11.1h-26.4L473.5,2.2z M495.5,57.3l-8.4-29l-8.5,29
			H495.5z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M538.3,2.2h27.3v83.7h-27.3V2.2z"
            />
            <LightPath
              innerRef={el => this.letters.push(el)}
              d="M582.1,2.2h40c24,0,34.9,6.2,34.9,24.1c0,10.2-4.3,16.8-13.5,20.7c9.3,2,13.3,7.2,13.6,18.6l0.5,11.6
			c0.1,3.6,0.1,5.2,2.4,5.5v3.1h-27.1c-1-4.3-1.5-7.2-1.5-8.7v-8.4c0-8.7-3.1-11.8-11.4-11.8h-11.4v28.9h-26.5V2.2z M620.8,38.2
			c7.7,0,11.3-1.5,11.3-7.8c0-6.7-3.8-7.9-12-7.9h-11.5v15.7H620.8z"
            />
          </g>
          <g>
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M6.6,262.9V108h60.5l21.5,77.4c0.4,1.9,2.2,9.5,5.2,22.6c2.2-11.2,3.9-18.7,5-22.4l22-77.6h60.6v154.9h-45
			l0.4-76.3c0-3.9,0-13.1,0.2-27.2c-2.8,13.1-5.2,22.4-6.5,27.6l-19.2,75.8H76.6l-19.4-74.1c-2.2-8.4-4.1-18.1-6.2-29.3
			c0.4,13.4,0.6,22.8,0.6,28.7v74.8H6.6z"
            />
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M249.8,108h50.4l54.5,154.9h-49.3l-5.8-20.5h-49.3l-6,20.5h-48.9L249.8,108z M290.6,209.9l-15.5-53.7
			l-15.7,53.7H290.6z"
            />
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M369,108h49.3v51.3L463,108h57.7l-55.4,57.1l62.5,97.8h-59.3l-37.9-62.1l-12.3,12.7v49.3H369V108z"
            />
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M537.1,108H661v37.1h-74.1v20.7h62.7v35.6h-62.7v23.9H664v37.7H537.1V108z"
            />
          </g>
          <g>
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M6,440.9V289.4h59.2l21.1,75.6c0.4,1.9,2.1,9.3,5.1,22.1c2.1-11,3.8-18.3,4.8-21.9l21.5-75.8h59.2v151.4h-44
			l0.4-74.6c0-3.8,0-12.8,0.2-26.5c-2.7,12.8-5.1,21.9-6.3,27l-18.7,74.1H74.5l-19-72.5c-2.1-8.2-4-17.7-6.1-28.6
			c0.4,13.1,0.6,22.3,0.6,28v73.1H6z"
            />
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M277.7,285.4c48.7,0,78.6,30.5,78.6,79.8c0,49.3-29.9,79.8-78.6,79.8c-48.7,0-78.8-30.5-78.8-79.8
			C198.9,316,229,285.4,277.7,285.4z M277.7,407c20.6,0,29.5-13.3,29.5-41.7s-8.8-41.7-29.5-41.7c-20.6,0-29.7,13.3-29.7,41.7
			S257.1,407,277.7,407z"
            />
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M378.6,289.4H451c43.4,0,63.2,11.2,63.2,43.6c0,18.5-7.8,30.3-24.4,37.5c16.9,3.6,24,13.1,24.6,33.7l0.8,21.1
			c0.2,6.5,0.2,9.5,4.4,9.9v5.7h-49.1c-1.9-7.8-2.7-13.1-2.7-15.8v-15.2c0-15.8-5.7-21.3-20.6-21.3h-20.6v52.2h-48V289.4z
			 M448.7,354.5c13.9,0,20.4-2.7,20.4-14.1c0-12.2-7-14.3-21.7-14.3h-20.9v28.4H448.7z"
            />
            <DarkPath
              innerRef={el => this.letters.push(el)}
              d="M539.3,289.4h121.1v36.2h-72.5v20.2h61.3v34.8h-61.3V404h75.4v36.9H539.3V289.4z"
            />
          </g>
        </g>
      </Container>
    )
  }
}

export default CammTitle



// WEBPACK FOOTER //
// ./src/Kiosk/AttractLoopView/CammTitle.js